<template>
  <section id="ValuationService">
    <div hidden>Audi old car, DCH Certified Audi PreOwned, DCH Certified Audi PreOwned, Audi認可二手, 奧迪認可二手, Audi認可易手車, 奧迪認可易手車</div>
    <!-- <div id="banner" class="animate__animated animate__fadeIn">
        <div class="container-fluid">
            <div class="row">
                <img class="hidden-xs" src="../picture/valuation-1920x600.jpg" />
                <img class="visible-xs" src="../picture/valuation-883x496.jpg" />
            </div>
        </div>
    </div> -->
    <div id="banner"
         class="animate__animated animate__fadeIn">
      <div class="container-fluid">
        <div class="row">
          <picture>
            <source media="(min-width: 768px)"
                    srcset="../picture/search1.jpg">
            <source media="(min-width: 1px)"
                    srcset="../picture/search2.jpg">
            <img src="../picture/search1.jpg" />
          </picture>
          <!-- <img class="hidden-xs" src="../picture/search1.jpg" />
                <img class="visible-xs" src="../picture/search2.jpg" /> -->
        </div>
      </div>
    </div>

    <div id="main">
      <div class="container">
        <div class="contents-hd">
          <h2>{{$t('valuationservice.h2')}}</h2>
        </div>
        <div class="row">
          <div class="col-md-10">
            <p class="p mt-3">{{$t('valuationservice.p')}}</p>
          </div>
        </div>

        <form ref="valuationForm"
              class="contents-bd">
          <h4>{{$t('valuationservice.h4')}}</h4>
          <div class="row">
            <div class="em col mt-2">*{{$t('form_c.mandatory')}}</div>
            <div class="w-100 mb-4"></div>
            <div class="col-sm-6 col-md-5 mb-3">
              <fieldset class="aui-fieldset aui-fieldset--selects">
                <div class="aui-select is-focused">
                  <select class="aui-select__input"
                          v-validate="'required'"
                          name="carModelName"
                          v-model="valuationForm.carModelId"
                          @focus="selectFn($event)"
                          @blur="selectBr($event, valuationForm.carModelId)"
                          @change="selectCarModels(valuationForm.carModelId, 'on')">
                    <option selected
                            disabled
                            class="aui-select__input-label"
                            value="">*{{$t('form_c.carmodel')}}</option>
                    <optgroup v-for="carModeItem in carSeriesAndModelsList"
                              :key="carModeItem.carSeriesId"
                              :label="carModeItem.carSeriesName"
                              :value="carModeItem.carSeriesId">
                      <option v-for="item in carModeItem.carModels"
                              :key="item.id"
                              :value="item.id">{{item.carModel}}</option>
                    </optgroup>
                    <optgroup label="Other">
                      <option class="aui-select__input-label"
                              value="-1">{{$t('form_c.otherbrands')}}</option>
                    </optgroup>
                  </select>
                  <label class="aui-select__label">{{$t('form_c.carmodel')}}<span class="red">*</span></label>
                  <span class="aui-select__focus-line"></span>
                  <span class="textfield__counter"
                        v-show="errors.has('carModelName')">{{ errors.first('carModelName') }}</span>
                </div>
              </fieldset>
            </div>

            <div class="col-sm-6 col-md-5 mb-3">
              <fieldset class="aui-fieldset aui-fieldset--selects">
                <div class="aui-textfield"
                     :style="{visibility: model_on ? '': 'hidden'}">
                  <div class="aui-textfield__field">
                    <input class="aui-textfield__input"
                           type="text"
                           name="otherModel"
                           maxlength="10"
                           v-model="valuationForm.otherModel"
                           @focus="inputFn($event)"
                           @blur="inputBr($event, valuationForm.otherModel)">
                    <label class="aui-textfield__label">{{$t('form_c.pleasespecify')}}</label>
                    <span class="aui-textfield__focus-line"></span>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="col-sm-6 col-md-5 mb-3">
              <fieldset class="aui-fieldset aui-fieldset--selects">
                <legend class="aui-fieldset__legend">{{$t('form_c.manufacturedate')}}</legend>
                <div class="aui-fieldset__fields">
                  <div class="aui-fieldset__field">
                    <div class="aui-select ">
                      <select class="aui-select__input"
                              name="delivery_year"
                              v-model="valuationForm.delivery_year"
                              @focus="selectFn($event)"
                              @blur="selectBr($event, valuationForm.delivery_year)">
                        <option selected
                                disabled
                                class="aui-select__input-label"
                                value="">{{$t('form_c.year')}}</option>
                        <option>2011</option>
                        <option>2012</option>
                        <option>2013</option>
                        <option>2014</option>
                        <option>2015</option>
                        <option>2016</option>
                        <option>2017</option>
                        <option>2018</option>
                        <option>2019</option>
                        <option>2020</option>
                      </select>
                      <label class="aui-select__label">{{$t('form_c.year')}}</label>
                      <span class="aui-select__focus-line"></span>
                    </div>
                  </div>
                  <!-- <div class="aui-fieldset__field">
                            <div class="aui-select aui-js-select ">
                                <select class="aui-select__input" name="delivery_month" v-model="valuationForm.delivery_month" @focus="selectFn($event)" @blur="selectBr($event, valuationForm.delivery_month)">
                                  <option selected disabled class="aui-select__input-label" value="">Month</option>
                                  <option>1</option>
                                  <option>2</option>
                                  <option>3</option>
                                  <option>4</option>
                                  <option>5</option>
                                  <option>6</option>
                                  <option>7</option>
                                  <option>8</option>
                                  <option>9</option>
                                  <option>10</option>
                                  <option>11</option>
                                  <option>12</option>                                                
                                </select>
                                <label class="aui-select__label">Month</label>
                                <span class="aui-select__focus-line"></span>
                            </div>
                        </div> -->
                </div>
              </fieldset>
            </div>
            <div class="col-sm-6 col-md-5 mb-3">
              <fieldset class="aui-fieldset aui-fieldset--selects">
                <legend class="aui-fieldset__legend aui-fieldset__legend">{{$t('form_c.registrationdate')}}</legend>
                <div class="aui-fieldset__fields">
                  <div class="aui-fieldset__field">
                    <div class="aui-select aui-js-select">
                      <select class="aui-select__input"
                              name="issue_year"
                              v-model="valuationForm.issue_year"
                              @focus="selectFn($event)"
                              @blur="selectBr($event, valuationForm.issue_year)">
                        <option selected
                                disabled
                                class="aui-select__input-label"
                                value="">{{$t('form_c.year')}}</option>
                        <option>2011</option>
                        <option>2012</option>
                        <option>2013</option>
                        <option>2014</option>
                        <option>2015</option>
                        <option>2016</option>
                        <option>2017</option>
                        <option>2018</option>
                        <option>2019</option>
                        <option>2020</option>
                      </select>
                      <label class="aui-select__label">{{$t('form_c.year')}}</label>
                      <span class="aui-select__focus-line"></span>
                    </div>
                  </div>
                  <div class="aui-fieldset__field">
                    <div class="aui-select aui-js-select">
                      <select class="aui-select__input"
                              name="issue_month"
                              v-model="valuationForm.issue_month"
                              @focus="selectFn($event)"
                              @blur="selectBr($event, valuationForm.issue_month)">
                        <option selected
                                disabled
                                class="aui-select__input-label"
                                value="">{{$t('form_c.month')}}</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                        <option>11</option>
                        <option>12</option>
                      </select>
                      <label class="aui-select__label">{{$t('form_c.month')}}</label>
                      <span class="aui-select__focus-line"></span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="col-sm-6 col-md-5 mb-3">
              <div class="aui-textfield">
                <div class="aui-textfield__field">
                  <input class="aui-textfield__input"
                         type="number"
                         v-validate="'required'"
                         name="mileage"
                         maxlength="6"
                         min="0"
                         max="150000"
                         v-model="valuationForm.mileage"
                         @focus="inputFn($event)"
                         @blur="inputBr($event, valuationForm.mileage)">
                  <label class="aui-textfield__label">{{$t('form_c.mileage')}}<span class="red">*</span></label>
                  <span class="aui-textfield__focus-line"></span>
                  <span class="aui-select__focus-line"></span>
                </div>
                <span class="textfield__counter"
                      v-show="errors.has('mileage')">{{ errors.first('mileage') }}</span>
              </div>
            </div>
            <div class="col-sm-6 col-md-5 mb-3">
              <div class="aui-textfield">
                <div class="aui-textfield__field">
                  <input class="aui-textfield__input"
                         type="text"
                         name="license_no"
                         v-validate="'ioq'"
                         maxlength="10"
                         v-model="valuationForm.license_no"
                         @focus="inputFn($event)"
                         @blur="inputBr($event, valuationForm.license_no)">
                  <label class="aui-textfield__label">{{$t('form_c.carplatenumber')}}</label>
                  <span class="aui-textfield__focus-line"></span>

                  <span class="textfield__counter"
                        v-show="errors.has('license_no')">{{ errors.first('license_no') }}</span>
                </div>
              </div>
            </div>

            <div class="w-100 mb-4"></div>

            <div class="col-sm-6 col-md-5 mb-3">
              <div class="aui-select aui-js-select">
                <select class="aui-select__input"
                        name="color_id"
                        v-validate="'required'"
                        v-model="valuationForm.color_id"
                        @focus="selectFn($event)"
                        @blur="selectBr($event, valuationForm.color_id)">
                  <option selected
                          disabled
                          class="aui-select__input-label"
                          value="">{{$t('form_c.exteriorcolour')}}*</option>
                  <option value="白">{{$t('form_c.colourList[0]')}}</option>
                  <option value="黑">{{$t('form_c.colourList[1]')}}</option>
                  <option value="紅">{{$t('form_c.colourList[2]')}}</option>
                  <option value="銀">{{$t('form_c.colourList[3]')}}</option>
                  <option value="灰">{{$t('form_c.colourList[4]')}}</option>
                  <option value="藍">{{$t('form_c.colourList[5]')}}</option>
                  <option value="棕">{{$t('form_c.colourList[6]')}}</option>
                  <option value="橘">{{$t('form_c.colourList[7]')}}</option>
                  <option value="黃">{{$t('form_c.colourList[8]')}}</option>
                  <option value="米">{{$t('form_c.colourList[9]')}}</option>
                  <option value="綠">{{$t('form_c.colourList[10]')}}</option>
                  <option value="其他">{{$t('form_c.colourList[11]')}}</option>
                </select>
                <label class="aui-select__label">{{$t('form_c.exteriorcolour')}}<span class="red">*</span></label>
                <span class="aui-select__focus-line"></span>
                <span class="textfield__counter"
                      v-show="errors.has('color_id')">{{ errors.first('color_id') }}</span>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 col-sm-6 col-md-5 mb-3">
              <div class="aui-textfield">
                <div class="aui-textfield__field">
                  <input class="aui-textfield__input"
                         type="text"
                         name="vin_num"
                         v-validate="'vim'"
                         maxlength="17"
                         v-model="valuationForm.vin_num"
                         @focus="inputFn($event)"
                         @blur="inputBr($event, valuationForm.vin_num)">
                  <label class="aui-textfield__label">{{$t('form_c.vinnumber')}}</label>
                  <span class="aui-textfield__focus-line"></span>
                  <span class="textfield__counter"
                        v-show="errors.has('vin_num')">{{ errors.first('vin_num') }}</span>

                </div>
              </div>
            </div>

            <div class="w-100 mb-4"></div>

            <div class="col-sm-12 col-xs-12  col-lg-12 mb-3">
              <label class="aui-select-num aui-js-checkbox">
                <!-- <input class="aui-checkbox__input" type="checkbox" name="is_first_hand" :value="valuationForm.is_first_hand ? 1 : 0" checked v-model="valuationForm.is_first_hand"> -->
                <span class="aui-checkbox__label">{{$t('form_c.numberofpreviousowner')}}</span>
                <div class="aui-select aui-js-select">
                  <select class="aui-select__input"
                          style="cursor: pointer;"
                          name="firstHand"
                          v-model="valuationForm.firstHand"
                          @focus="selectFn($event)"
                          @blur="selectBr($event, valuationForm.firstHand)">
                    <option selected
                            disabled
                            class="aui-select__input-label"
                            value=""></option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option :value="$t('form_c.morethan')">{{$t('form_c.morethan')}}</option>
                  </select>
                  <label class="aui-select__label"> </label>
                  <span class="aui-select__focus-line"></span>
                </div>
                <!-- <span class="aui-checkbox__box"><span class="aui-checkbox__tick iconfont">&#xe60e;</span></span> -->
              </label>
              <fieldset class="aui-radios-yn aui-fieldset aui-fieldset-radios ml-4">
                <div class="aui-fieldset__fields">
                  <div class="aui-fieldset__field">
                    <label :class="['aui-radio aui-js-checkbox', valuationForm.is_want_newaudi == 0 ? '' : 'is-checked']"
                           @change="checkboxCl($event)">
                      <input class="aui-radio__input"
                             type="checkbox"
                             name="is_want_newaudi"
                             :value="valuationForm.is_want_newaudi ? 1: 0"
                             v-model="valuationForm.is_want_newaudi">
                      <!-- <input class="aui-checkbox__input" type="radio" name="is_want_newaudi" :value="valuationForm.is_want_newaudi ? 1: 0" checked v-model="valuationForm.is_want_newaudi"> -->
                      <span class="aui-radio__label">{{$t('form_c.intendtotradein')}}</span>
                      <span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="col-sm-12 col-xs-12">
              <fieldset class="aui-fieldset aui-fieldset-radios">
                <legend class="aui-fieldset__legend aui-fieldset__legend">{{$t('form_c.purchasefrom')}}:</legend>
                <div class="aui-fieldset__fields">
                  <div class="aui-fieldset__field">
                    <label :class="['aui-radio', valuationForm.distributors == 0 ? 'is-checked' : '']">
                      <input class="aui-radio__input"
                             type="radio"
                             name="distributors"
                             value="0"
                             checked
                             v-model="valuationForm.distributors">
                      <span class="aui-radio__label">{{$t('form_c.audihongkongdealer')}}</span>
                      <span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                    </label>
                  </div>
                  <div class="aui-fieldset__field">
                    <label :class="['aui-radio', valuationForm.distributors == 1 ? 'is-checked' : '']">
                      <input class="aui-radio__input"
                             type="radio"
                             name="distributors"
                             value="1"
                             v-model="valuationForm.distributors">
                      <span class="aui-radio__label">{{$t('form_c.others')}}</span>
                      <span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="col-sm-12 col-xs-12 col-sm-6 col-md-5 mb-3"
                 :style="{display: (valuationForm.distributors == 1 ? 'block' : 'none')}">
              <div class="aui-textfield aui-js-textfield">
                <div class="aui-textfield__field">
                  <input class="aui-textfield__input"
                         type="text"
                         name="distributors_other"
                         maxlength="20"
                         value=""
                         v-model="valuationForm.distributors_other"
                         @focus="inputFn($event)"
                         @blur="inputBr($event, valuationForm.distributors_other)">
                  <label class="aui-textfield__label">{{$t('form_c.others')}}</label>
                  <span class="aui-textfield__focus-line"></span>
                </div>
              </div>
            </div>

            <!-- <div class="col-sm-12 col-xs-12">
                <fieldset class="aui-fieldset aui-fieldset-radios">
                    <legend class="aui-fieldset__legend aui-fieldset__legend">Optional Accessories:</legend>
                    <div class="aui-fieldset__fields" @change="radioClList($event)">
                        <div class="aui-fieldset__field mb-2">
                            <label :class="['aui-radio', valuationForm.is_optional == 0 ? 'is-checked' : '']">
                              <input class="aui-radio__input" type="radio" name="is_optional" value="0" checked v-model="valuationForm.is_optional">
                              <span class="aui-radio__label">NO</span><span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                            </label>
                        </div>
                        <div class="aui-fieldset__field mb-2">
                            <label :class="['aui-radio', valuationForm.is_optional == 1 ? 'is-checked' : '']">
                              <input class="aui-radio__input" type="radio" name="is_optional" value="1" v-model="valuationForm.is_optional">
                              <span class="aui-radio__label">YES<span class="aui-small">(Please tick)</span></span><span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                            </label>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div id="options-sub-fields" class="col-sm-12 col-xs-12" :style="{display: (valuationForm.is_optional == 1 ? 'block' : 'none')}">
              <div class="row">
                <div class="col-sm-6 col-md-5" v-for="(item, index) in equipmentsList" :key="index">
                  <label class="aui-checkbox aui-js-checkbox" @change="checkboxLs($event, index, item.value)">
                    <input class="aui-checkbox__input" type="checkbox" :checked="item.checked" :value="item.value" >
                    <span class="aui-checkbox__label">{{item.value}}</span>
                    <span class="aui-checkbox__box"><span class="aui-checkbox__tick iconfont">&#xe60e;</span></span>
                  </label>
                </div>

                <div class="w-100 mb-4"></div>

                <div class="col-sm-12 col-xs-12 col-sm-6 col-md-5 mt-1 mb-3">
                  <div class="aui-textfield aui-js-textfield">
                    <div class="aui-textfield__field">
                      <input class="aui-textfield__input" type="text" name="equipments_other" maxlength="100" v-model="valuationForm.equipments_other" @focus="inputFn($event)" @blur="inputBr($event, valuationForm.equipments_other)">
                      <label class="aui-textfield__label">Others</label>
                      <span class="aui-textfield__focus-line"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="w-100 mb-5"></div>

            <div class="col-sm-12 col-xs-12">
              <h4>{{$t('form_c.h4')}}</h4>
              <div id="contact-fields">
                <div class="row">
                  <div class="em col mt-2">*{{$t('form_c.mandatory')}}</div>
                  <div data-v-7f7a5818=""
                       class="w-100 mb-4"></div>
                  <fieldset class="aui-fieldset aui-fieldset--selects ">
                    <div class="col-sm-12 col-xs-12 mb-my-3 my-left"
                         style="padding: 0;">
                      <div class="col-my-5 col-sm-3 col-xs-5 col-md-2 my-padding-right">
                        <div class="aui-select aui-js-select">
                          <select class="aui-select__input"
                                  name="userTitle"
                                  v-validate="'required'"
                                  v-model="valuationForm.userTitle"
                                  @focus="selectFn($event)"
                                  @blur="selectBr($event, valuationForm.userTitle)">
                            <option selected
                                    disabled
                                    class="aui-select__input-label"
                                    value="">{{$t('form_c.title')}}*</option>
                            <option value="Mr.">{{$t('form_c.titleList[0]')}}</option>
                            <option value="Mrs.">{{$t('form_c.titleList[1]')}}</option>
                            <option value="Ms.">{{$t('form_c.titleList[2]')}}</option>
                            <option value="Dr.">{{$t('form_c.titleList[3]')}}</option>
                            <option value="Professor">{{$t('form_c.titleList[4]')}}</option>
                          </select>
                          <label class="aui-select__label">{{$t('form_c.title')}}<span class="red">*</span></label>
                          <span class="aui-select__focus-line"></span>
                          <span class="textfield__counter"
                                v-show="errors.has('userTitle')">{{ errors.first('userTitle') }}</span>
                        </div>
                      </div>
                      <div class="col-my-7 col-sm-4 col-xs-7 col-md-4">
                        <div class="aui-textfield aui-js-textfield">
                          <div class="aui-textfield__field">
                            <input class="aui-textfield__input"
                                   type="text"
                                   v-validate="'required'"
                                   name="userLastname"
                                   maxlength="10"
                                   value=""
                                   v-model="valuationForm.userLastname"
                                   @focus="inputFn($event)"
                                   @blur="inputBr($event, valuationForm.userLastname)">
                            <label class="aui-textfield__label">{{$t('form_c.lastame')}}<span class="red">*</span></label>
                            <span class="aui-textfield__focus-line"></span>
                          </div>
                          <span class="textfield__counter"
                                v-show="errors.has('userLastname')">{{ errors.first('userLastname') }}</span>
                        </div>
                      </div>
                      <div class="col-my-12 col-sm-5 col-xs-12 col-md-4">
                        <div class="aui-textfield aui-js-textfield mt-xs-4">
                          <div class="aui-textfield__field">
                            <input class="aui-textfield__input"
                                   type="text"
                                   v-validate="'required'"
                                   name="userFirstname"
                                   maxlength="10"
                                   value=""
                                   v-model="valuationForm.userFirstname"
                                   @focus="inputFn($event)"
                                   @blur="inputBr($event, valuationForm.userFirstname)">
                            <label class="aui-textfield__label">{{$t('form_c.firstname')}}<span class="red">*</span></label>
                            <span class="aui-textfield__focus-line"></span>
                          </div>
                          <span class="textfield__counter"
                                v-show="errors.has('userFirstname')">{{ errors.first('userFirstname') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 col-sm-6 col-md-5 my-left">
                      <div class="aui-textfield aui-js-textfield mt-4">
                        <div class="aui-textfield__field number-relative"
                             @focus="inputFn($event)"
                             @blur="inputBr($event, valuationForm.email)">
                          <em>+852</em>
                          <input class="aui-textfield__input number-input"
                                 type="text"
                                 v-validate="'required|numeric'"
                                 name="mobile"
                                 maxlength="15"
                                 value=""
                                 v-model="valuationForm.mobile"
                                 @focus="inputFn($event)"
                                 @blur="inputBr($event, valuationForm.mobile)">
                          <label class="aui-textfield__label">{{$t('form_c.mobilenumber')}}<span class="red">*</span>
                            <!-- <small class="aui-small">Mobile Number ex. 0912345678</small> -->
                          </label>
                          <span class="aui-textfield__focus-line"></span>
                        </div>
                        <span class="textfield__counter"
                              v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                      </div>
                      <div class="aui-textfield aui-js-textfield mt-4">
                        <div class="aui-textfield__field">
                          <input class="aui-textfield__input"
                                 type="email"
                                 v-validate="'required|email'"
                                 name="emailAdd"
                                 maxlength="100"
                                 value=""
                                 v-model="valuationForm.email"
                                 @focus="inputFn($event)"
                                 @blur="inputBr($event, valuationForm.email)">
                          <label class="aui-textfield__label">{{$t('form_c.email')}}<span class="red">*</span></label>
                          <span class="aui-textfield__focus-line"></span>
                        </div>
                        <span class="textfield__counter"
                              v-show="errors.has('emailAdd')">{{ errors.first('emailAdd') }}</span>
                      </div>
                      <div class="aui-select aui-js-select mt-4">
                        <select class="aui-select__input"
                                name="contact_time"
                                v-validate="'required'"
                                v-model="valuationForm.contact_time"
                                @focus="selectFn($event)"
                                @blur="selectBr($event, valuationForm.contact_time)">
                          <option selected
                                  disabled
                                  class="aui-select__input-label"
                                  value="">{{$t('form_c.contactperiod')}}*</option>
                          <option>{{$t('form_c.am')}} 09:30-12:30</option>
                          <option>{{$t('form_c.am')}} 01:00-06:00</option>
                          <option>{{$t('form_c.pm')}} 06:00-10:00</option>
                        </select>
                        <label class="aui-select__label">{{$t('form_c.contactperiod')}}<span class="red">*</span></label>
                        <span class="aui-dropdown__error"></span>
                        <span class="textfield__counter"
                              v-show="errors.has('contact_time')">{{ errors.first('contact_time') }}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 col-sm-6 col-md-5 my-left">
                      <!-- <div class="aui-select aui-js-select">
                            <select class="aui-select__input" name="showroom" v-validate="'required'" v-model="valuationForm.showroom" @focus="selectFn($event)" @blur="selectBr($event, valuationForm.showroom)">
                              <option selected disabled class="aui-select__input-label" value="">Service Centre*</option>
                              <option value="【內湖】台北市內湖區行忠路178巷2號">【內湖】台北市內湖區行忠路178巷2號</option>
                              <option value="【新莊】新北市新莊區中正路54號">【新莊】新北市新莊區中正路54號</option>
                              <option value="【南屯】台中市南屯區公益路二段999號">【南屯】台中市南屯區公益路二段999號</option>
                              <option value="3">【高雄】高雄市左營區新莊一路306號</option>
                            </select>
                            <label class="aui-select__label">Service Centre<span class="red">*</span></label>
                            <span class="aui-dropdown__error"></span>
                            <span class="textfield__counter"  v-show="errors.has('showroom')">{{ errors.first('showroom') }}</span>
                        </div> -->

                      <div class="aui-textfield aui-js-textfield aui-textfield-multiline mt-5"
                           data-autosize
                           data-count="200">
                        <div class="aui-textfield__field">
                          <textarea class="aui-textfield__input"
                                    name="message"
                                    rows="3"
                                    maxlength="200"
                                    v-model="valuationForm.message"
                                    @focus="inputFn($event)"
                                    @blur="inputBr($event, valuationForm.message)"
                                    @input="descInput"></textarea>
                          <label class="aui-textfield__label">{{$t('form_c.remarks')}} <span class="aui-small">{{$t('form_c.remarks_limit')}}</span></label>
                          <span class="aui-textfield__focus-line"></span>
                        </div>
                        <span class="aui-textfield__counter"><span class="aui-textfield__counter-value">{{remnant}}</span></span>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div class="w-100 mb-10"></div>

              <!-- <h5 class="mb-4"><a href="javascript:;" >個人資料運用告知聲明</a></h5> -->
              <div id="privacy-fields">
                <!-- <div class="row mt-4"> -->
                  <!-- <div class="col-sm-12 col-xs-12 col-md-10">
                    <p class="aui-small"
                       v-html="$t('kamlungmotorslimited')"></p>

                      注注注注注注
                     <fieldset class="aui-fieldset aui-fieldset-radios mt-4 mb-3">
                      <div class="aui-fieldset__fields" @change="radioYN($event)">
                        <div class="aui-fieldset__field">
                            <label :class="['aui-radio', valuationForm.warranty == 1 ? 'is-checked' : '']">
                            <input class="aui-radio__input" type="radio" name="warranty"  value="1" checked v-model="valuationForm.warranty">
                            <span class="aui-radio__label">Agree</span>
                            <span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                          </label>
                        </div>
                        <div class="aui-fieldset__field">
                            <label :class="['aui-radio', valuationForm.warranty == 0 ? 'is-checked' : '']">
                            <input class="aui-radio__input" type="radio" name="warranty" value="0" v-model="valuationForm.warranty">
                            <span class="aui-radio__label">Disagree</span>
                            <span class="aui-radio__box"><span class="aui-radio__tick"></span></span>
                          </label>
                        </div>
                      </div>
                    </fieldset> 
                    注注注注注注

                  </div>
                </div> -->

                <div class="check-text">
                  <div class="col-sm-12 col-xs-12 check-p">
                    <label class="aui-checkbox aui-js-checkbox"
                           @change="checkboxCl($event)">
                      <input class="aui-checkbox__input"
                             type="checkbox"
                             name="Privacy_yn"
                             v-validate="'seeyn'"
                             :value="valuationForm.Privacy_yn ? true : false"
                             checked
                             v-model="valuationForm.Privacy_yn">
                      <span class="aui-checkbox__label">
                        <strong v-html="$t('Privacy_yn')">
                        </strong>
                      </span>
                      <span :class="['aui-checkbox__box', valuationForm.Privacy_yn == true ? 'is-checked' : '']">
                        <span class="aui-checkbox__tick iconfont">&#xe60e;</span>
                      </span>
                      <span class="textfield__counter ys"
                            v-show="errors.has('Privacy_yn')">{{ errors.first('Privacy_yn') }}</span>
                    </label>
                  </div>
                  <div class="col-sm-12 col-xs-12 check-p">
                    <label class="aui-checkbox aui-js-checkbox ml-4"
                           @change="checkboxCl($event)">
                      <input class="aui-checkbox__input"
                             type="checkbox"
                             name="warranty"
                             :value="valuationForm.warranty ? true: false"
                             checked
                             v-model="valuationForm.warranty">
                      <span class="aui-checkbox__label"><strong v-html="$t('warranty')"></strong></span>
                      <span :class="['aui-checkbox__box', valuationForm.warranty == true ? 'is-checked' : '']"><span class="aui-checkbox__tick iconfont">&#xe60e;</span></span>
                      <span class="textfield__counter ys grey" >{{ $t('PINNED') }}</span>

                    </label>
                  </div>
                </div>
              </div>

              <div class="w-100 mb-4"></div>

              <div class="aui-button-group mt-4">
                <van-button id="btn-valuation-submit"
                            :loading="load"
                            native-type="button"
                            class="aui-js-response aui-button aui-button-primary btn-loadable"
                            type="primary"
                            @click="onSubmit()">
                  <span class="aui-button__text">{{$t('submit')}}
                    <!-- <i class="iconfont">&#xe60e;</i> -->
                  </span>
                </van-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { reqAddValuationCar, reqGetCarSeriesAndModels, reqGetCarStyleList } from '../untils/api.js';
import { Toast, Button } from 'vant'


export default {
  metaInfo: {
    title: 'approvedplus.hk - Value My Car', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Audi old car, DCH Certified Audi PreOwned, DCH Certified Audi PreOwned, Audi認可二手, 奧迪認可二手, Audi認可易手車, 奧迪認可易手車'
    },
    {
      name: 'description',
      content: 'The only Audi authorized pre-owned centre in Hong Kong, 100% proven quality. Explore the one-stop service now! Enquiry: 22910000. 奧迪認可易手車中心，全港唯一原廠認證，100%品質保證，立即體驗一站式交易服務，查詢請致電22910000。'
    }]
  },
  name: "ValuationService",
  inject: ['reload'],
  data () {
    return {
      load: false,
      remnant: 200, //文本框字数
      carSeriesAndModelsList: [],
      // carStyleList: [],
      model_on: false,
      valuationForm: {
        carSeriesId: '',   //系列ID
        carSeriesName: '',  //系列名称
        carModelId: '', 		//车型ID
        carModelName: '',   //车型名称
        // carStyleId: '',     //车款ID 
        // carStyleName: '',   //车款名称
        otherModel: '', //其他车型
        delivery_year: '',
        // delivery_month: '',
        issue_year: '',
        issue_month: '',
        mileage: '', //里程數 (公里)
        license_no: '', //車牌號碼
        color_id: '', //車體顏色
        is_first_hand: false, //复选框
        firstHand: '',  //复选框为true，显示下拉选择
        is_want_newaudi: false, //复选框
        vin_num: '',  //VIN Number
        distributors: false,  //单选按钮-显示其他文本框
        distributors_other: '', //其他管道
        // is_optional: false,   //单选按钮-显示列表
        // equipments: [], //显示列表多选框
        // equipments_other: '', //显示列表-其他選配
        name: '', //姓名
        userTitle: '', //姓名-标题
        userLastname: '', //姓名-姓
        userFirstname: '', //姓名-名

        mobile: '', //电话
        email: '', //Email
        contact_time: '', //可聯絡時段
        // showroom: '', // 指定展示中心
        message: '', //内容框
        warranty: false, //是否同意锦龙获取隐私
        Privacy_yn: false
      },
      equipmentsList: [
        { value: 'Alloy wheels', checked: false },
        { value: 'S line sport package', checked: false },
        { value: 'Audi exclusive package(no particular meaning, no further info?)', checked: false },
        { value: 'Comfort key', checked: false },
        { value: 'MMI 3G+(need to specify which MMI system it is referring to)', checked: false },
        { value: 'Full LED headlight', checked: false },
        { value: 'Adaptive cruise control', checked: false },
        { value: 'Lane departure warning', checked: false },
        { value: 'Lane change assist', checked: false },
        { value: 'Audi pre sense front', checked: false }
      ]
    };
  },
  components: {},
  mounted () {
    PubSub.subscribe('locale', (msg, data) => {
      if (data.locale != '') {
        this.reload()
        this.$validator.locale = this.$store.state.locale
      }
    })
    setTimeout(() => {
      this.carSeriesAndModels()
    }, 200)
  },
  methods: {
    // PrivacyYn(e) {
    //   this.valuationForm.Privacy_yn = e.currentTarget.checked
    // },
    descInput () {
      let txtVal = this.valuationForm.message.length
      this.remnant = 200 - txtVal
    },
    //车型车款
    carSeriesAndModels () {
      reqGetCarSeriesAndModels().then(res => {
        this.carSeriesAndModelsList = res.data.carSeriesAndModels
      })
    },
    selectCarModels (id, on) {
      if (on == 'on') {
        this.valuationForm.carStyleId = ''
        this.valuationForm.carStyleName = ''
      }

      if (id == '-1') {
        this.model_on = true
      } else {
        this.model_on = false
      }

      // let data = {
      // 	carModelId: id
      // }
      // reqGetCarStyleList(data).then(res => {
      //   this.$nextTick(() => {
      //     this.carStyleList = res.data.carStyleList
      //   })
      // })
    },
    selectFn (e) {
      return e.currentTarget.parentElement.classList.add('aui-select-floating-label', 'is-dirty')
    },
    selectBr (e, val) {
      if (val == null || val == '') {
        return e.currentTarget.parentElement.classList.remove('aui-select-floating-label', 'is-dirty')
      }
    },
    inputFn (e) {
      return e.currentTarget.parentElement.parentElement.classList.add('aui-textfield-floating-label', 'is-dirty')
    },
    inputBr (e, val) {
      if (val == null || val == '') {
        return e.currentTarget.parentElement.parentElement.classList.remove('aui-textfield-floating-label', 'is-dirty')
      }
    },
    checkboxCl (e) {
      if (e.type == 'change') {
        if (e.target.checked == true) {
          e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.add('is-checked')
        } else if (e.target.checked == false) {
          // this.valuationForm.Privacy_yn = e.target.checked
          e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.remove('is-checked')
        }
      } else {
        this.valuationForm.is_first_hand = true
        if (this.valuationForm.is_first_hand == true) {
          e.currentTarget.previousElementSibling.nextElementSibling.nextElementSibling.classList.add('is-checked')
        }
      }
    },
    radioCl (e) {
      this.valuationForm.distributors = e.target.value
    },
    radioClList (e) {
      this.valuationForm.is_optional = e.target.value
    },
    checkboxLs (e, i, value) {
      if (this.equipmentsList[i].checked == false) {
        e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.add('is-checked')
        this.equipmentsList[i].checked = true
        this.valuationForm.equipments.push(value)

      } else if (this.equipmentsList[i].checked == true) {
        e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.remove('is-checked')
        this.equipmentsList[i].checked = false
        this.valuationForm.equipments.forEach((val, id) => {
          if (val == value) {
            this.valuationForm.equipments.splice(id, 1)
          }
        })
      }
    },
    radioYN (e) {
      this.valuationForm.warranty = e.target.value
    },

    onSubmit () {
      this.$validator.validate().then(result => {
        if (!result) {
          Toast({ message: this.errors.all()[0], duration: 1500 });  // ui框架的提示弹窗
          return
        } else {
          this.load = true
          if (this.valuationForm.Privacy_yn == true) {
            let _ = this.valuationForm
            let data = {
              carModelId: _.carModelId,   //系列ID
              otherModel: _.otherModel,
              factoryDateYear: _.delivery_year,
              // factoryDateMonth: _.delivery_month,
              licensingDateYear: _.issue_year,
              licensingDateMonth: _.issue_month,
              mileages: _.mileage, //里程數 (公里)
              carPalteNumber: _.license_no, //車牌號碼
              exteriorColor: _.color_id, //車體顏色
              firstHand: _.firstHand, //复选框true,下拉选择
              intendToTradeIn: _.is_want_newaudi == 1 ? true : false, //复选框
              vin: _.vin_num,  //VIN Number
              // optional: _.distributors,  //单选按钮-显示其他文本框
              purchaseChannel: _.distributors == 0 ? 'Audi Hong Kong Dealer' : _.distributors_other, //其他管道
              // optional: _.is_optional == 1 ? true : false,   //单选按钮-显示列表
              // optionalItem: _.is_optional == 0 ? '無' : _.equipments.join(';'), //显示列表多选框
              // otherOptions: _.equipments_other, //显示列表-其他選配
              name: _.userTitle + _.userLastname + _.userFirstname, //姓名
              mobileNumber: '(+852)' + _.mobile, //电话
              email: _.email, //Email
              contactPeriod: _.contact_time, //可聯絡時段
              // serviceCentre: _.showroom, // 指定展示中心
              remark: _.message, //内容框
              agree: _.warranty, //是否同意隐私
							language: this.$store.state.locale
            }
            setTimeout(() => {
              reqAddValuationCar(data).then(res => {
                if (res.code == 200) {
                  this.load = false
                  Toast({ type: 'success', duration: 2000 })
                  this.reload()
                }
              })
            }, 700)
          } else {
            this.load = false

            Toast({ message: '*This is required.', duration: 2000 });  // ui框架的提示弹窗
          }
          //  this.handleSaveParam();   // 验证通过后请求接口的方法
        }
      })
    }
  },
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: button;
}

.em {
  font-size: 14px;
  font-style: italic;
  color: #8d8d8d;
}

.red {
  // color: #dc3545;
  color: rgba(0, 0, 0, 0.6);
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  // padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: inherit;
  white-space: normal;
  border-bottom: none;
}

#ValuationService {
  h4 {
    margin-top: 16px;
    margin-bottom: 0;
  }

  h5 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .p {
    font-size: 16px;
    line-height: 24px;
  }

  form {
    .aui-select__focus-line, .aui-textfield__focus-line {
      display: block;
      position: relative;
      width: 100%;
      margin-top: -2px;
      height: 1px;
      background: rgba(0, 0, 0, 0.8);
      opacity: 0;
      transition-property: opacity, background;
      transition-duration: 0.25s;
    }

    .aui-select {
      font-size: 16px;
      display: block;
      position: relative;
      margin: 0;
      box-sizing: border-box;
      padding-top: 10px;

      &::after {
        font-family: 'iconfont' !important;
        font-size: 24px;
        color: #888;
        content: '\e689';
        display: block;
        position: absolute;
        top: 23px;
        right: 0;
        width: 25px;
        height: 25px;
        transform: translateY(-50%);
        transition: background 0.25s linear;
        pointer-events: none;
      }

      &:hover .aui-select__input {
        border-color: rgba(0, 0, 0, 0.8);
      }

      &.is-dirty .aui-select__input {
        color: #000;
      }
    }

    .aui-select__input {
      display: block;
      margin: 0;
      padding-right: 28px;
      width: 100%;
      min-height: 40px;
      font-size: inherit;
      font-weight: 400;
      line-height: inherit;
      color: rgba(0, 0, 0, 0.6);
      background: 0 0;
      border: none;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 0;
      box-shadow: none;
      transition: color, border;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0;

      &:focus~.aui-select__focus-line {
        opacity: 1;
      }
    }

    .aui-select__label {
      display: block;
      position: absolute;
      top: 18px;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      color: rgba(0, 0, 0, 0.6);
      font-size: inherit;
      font-weight: 400;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition-property: top, font-size, color, opacity;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      opacity: 0;
      pointer-events: none;
    }

    .aui-select.is-focused .aui-select__input {
      outline: 0;
      box-shadow: none;
      border-color: rgba(0, 0, 0, 0.8);
    }

    .aui-select.aui-select-floating-label .aui-select__label {
      top: 0;
      font-size: 12px;
      opacity: 1;
    }

    // 第二横，下拉选择框
    .aui-fieldset {
      margin: 0;
      padding: 0;
      border: none;
      line-height: auto;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      box-sizing: border-box;

      .aui-fieldset__legend {
        font-size: 16px;
        font-weight: 700;
        color: #000;
        padding-top: 20px;
      }

      .aui-fieldset__fields {
        display: flex;

        .aui-fieldset__field {
          flex: 1 1 auto;
          margin-right: 25px;
          margin-bottom: 25px;

          &:nth-of-type(2) {
            margin-right: 0;
          }
        }
      }
    }

    // 第三横，文本 与 文选框
    .aui-textfield {
      display: block;
      position: relative;
      margin: 0;
      padding: 0;
      font-size: 16px;
      line-height: normal;
      stroke: #333;

      .number-relative {
        position: relative;

        em {
          position: absolute;
          top: 20px;
          left: 10px;
          font-size: 16px;
          font-style: normal;
          color: #666;
          opacity: 0;
          transition-duration: 0.25s;
          transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
        }

        .number-input {
          padding-left: 60px;
        }
      }

      // 文选框
      &.aui-textfield-multiline {
        padding-top: 20px;
        transition-property: padding;
        transition-duration: 0.25s;
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

        .aui-textfield__field {
          padding-top: 8px;
          border: 1px solid rgba(0, 0, 0, 0.3);

          .aui-textfield__input {
            padding-top: 10px;
            padding-left: 10px;
            padding-right: 10px;
            height: 99px;
          }

          .aui-textfield__label {
            top: 10px;
            left: 10px;
          }
        }

        &.is-dirty {
          .aui-textfield__field {
            padding-top: 28px;

            .aui-textfield__label {
              top: 4px;
            }
          }
        }
      }

      &.is-dirty {
        padding-top: 0;

        .aui-textfield__field {
          padding-top: 10px;
          border-bottom-color: rgba(0, 0, 0, 0.8);

          .aui-textfield__input {
            padding-top: 0;
            outline: 0;
            box-shadow: none;
          }

          .aui-textfield__label {
            top: 0;
            font-size: 12px;
            opacity: 1;
          }
        }

        .number-relative {
          em {
            opacity: 1;
          }
        }
      }

      .aui-textfield__field {
        padding-top: 10px;
        position: relative;
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);
        transition-property: border, padding;
        transition-duration: 0.25s;
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

        &:hover {
          border-bottom-color: rgba(0, 0, 0, 0.8);
        }

        .aui-textfield__input {
          display: block;
          margin: 0;
          // padding: 10px 0 10px;
          width: 100%;
          min-height: 40px;
          font-size: inherit;
          font-weight: 400;
          line-height: inherit;
          text-align: left;
          color: rgba(0, 0, 0, 0.6);
          background: 0 0;
          border: none;
          transition: color 0.25s cubic-bezier(0.75, 0.02, 0.5, 1);
          resize: none;
          outline: 0;
          border-radius: 0;

          &:focus~.aui-textfield__focus-line {
            opacity: 1;
          }
        }

        .aui-textfield__label {
          display: block;
          position: absolute;
          top: 20px;
          left: 0;
          width: 100%;
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: 400;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          pointer-events: none;
          transition-property: top, font-size, color, opacity;
          transition-duration: 0.25s;
          transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
          pointer-events: none;
        }
      }

      .aui-textfield__counter {
        position: relative;
        display: block;
        color: rgba(0, 0, 0, 0.5);
        transition: color 0.25s linear;
        margin-top: 5px;
        font-size: 13px;

        .aui-textfield__counter-value {
          display: block;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      &.is-dirty .aui-textfield__field .aui-textfield__input {
        color: #000;
      }
    }

    .aui-textfield.aui-textfield-floating-label .aui-textfield__label {
      top: 0;
      font-size: 12px;
      opacity: 1;
    }

    // 第五横，多选按钮
    .aui-checkbox {
      float: left;
      // display: inline-block;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      font-weight: 400;
      height: 44px;
      // line-height: 30px;
      // margin-top: 10px;
      margin-top: 0;
      padding-left: 50px;
      padding-right: 20px;
      margin-right: 16px;
      color: #000;
      box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.2);
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      transition: color, border;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      cursor: pointer;

      &:hover {
        .aui-checkbox__label {
          color: rgba(0, 0, 0, 1);
        }

        .aui-checkbox__box {
          border-color: rgba(0, 0, 0, 0.8);
        }
      }

      .aui-checkbox__label {
        font-size: 16px;
      }

      .aui-checkbox__input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        opacity: 0;
        z-index: -1;

        &:focus~.aui-checkbox__box {
          box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
        }
      }

      .aui-checkbox__box {
        display: inline-block;
        overflow: hidden;
        position: absolute;
        top: 7px;
        left: 0;
        width: 30px;
        height: 30px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        transition: box-shadow 0.15s linear, border 0.15s linear;
        cursor: pointer;
        pointer-events: none;
        z-index: 1;

        .aui-checkbox__tick {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: rgba(0, 0, 0, 0.5);
          transform: translate(-50%, -50%);
          opacity: 0;
          transition: opacity 0.15s cubic-bezier(0.75, 0.02, 0.5, 1);
          pointer-events: none;
        }

        &.is-checked .aui-checkbox__tick {
          opacity: 1;
        }
      }
    }

    // 第五横，选择
    .aui-select-num {
      overflow: hidden;
      float: left;
      position: relative;
      font-weight: 400;
      height: 60px;
      margin-top: 0;
      // padding-left: 50px;
      padding-right: 20px;
      margin-right: 16px;
      color: #000;
      -webkit-box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.2);
      box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.2);
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -webkit-transition: color, border;
      transition: color, border;
      -webkit-transition-duration: 0.25s;
      transition-duration: 0.25s;
      -webkit-transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      cursor: pointer;

      span {
        font-size: 16px;
      }

      .aui-select {
        display: inline-block;
        width: 176px;

        .aui-select__input {
          text-indent: 6px;
        }
      }
    }

    .aui-radios-yn {
      height: 60px;
      line-height: 60px;
      width: 100%;
    }

    // 第六、七横，单选按钮
    .aui-fieldset-radios {
      .aui-fieldset__fields {
        .aui-fieldset__field {
          -ms-flex: 0 1 auto;
          flex: 0 1 auto;

          .aui-radio {
            display: inline-block;
            position: relative;
            font-weight: 400;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            padding-left: 50px;
            margin-right: 16px;
            color: #000;
            cursor: pointer;
            -webkit-tap-highlight-color: transparent;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

            &.is-checked {
              .aui-radio__box {
                .aui-radio__tick {
                  background: rgba(0, 0, 0, 0.8);
                  transform: translate(-50%, -50%) scale(0.7, 0.7);
                }
              }
            }

            &:hover {
              color: #000;

              .aui-radio__box {
                border-color: #000;
              }

              .aui-radio__tick {
                transform: translate(-50%, -50%) scale(0.5 0.8, 0.5 0.8);
              }
            }

            &.is-dirty {
              color: #000;
            }

            .aui-radio__input {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              position: absolute;
              width: 0;
              height: 0;
              overflow: hidden;
              margin: 0;
              padding: 0;
              border: 0;
              outline: 0;
              opacity: 0;
              z-index: -1;

              &:focus~.aui-radio__box {
                box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
              }
            }

            .aui-radio__label {
              font-size: 16px;
            }

            .aui-radio__box {
              display: inline-block;
              overflow: hidden;
              position: absolute;
              top: 0;
              left: 0;
              width: 30px;
              height: 30px;
              line-height: 30px;
              border: 1px solid rgba(0, 0, 0, 0.5);
              border-radius: 50%;
              transition: box-shadow 0.15s linear, border 0.15s linear;
              cursor: pointer;
              pointer-events: none;
              z-index: 1;

              .aui-radio__tick {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 20px;
                height: 20px;
                line-height: 20px;
                transform: translate(-50%, -50%) scale(0.5, 0.5);
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.1);
                transition: transform 0.15s cubic-bezier(0.75, 0.02, 0.5, 1), background 0.15s linear;
                pointer-events: none;
              }
            }
          }
        }
      }
    }

    .check-text {
      overflow: hidden;
      // background: #e7e9ea;
      background: #f1f1f1;
      padding-bottom: 16px;

      .check-p {
        overflow: hidden;
        padding-top: 5px;
        padding-bottom: 10px;

        .aui-checkbox {
          margin: 0;
          // height: auto;
          box-shadow: none;
          -webkit-box-shadow: none;

          .aui-checkbox__box {
            .aui-checkbox__tick {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 100%;
              height: 100%;
              line-height: normal;
              color: #fff;
              background: #000;
            }
          }

          .aui-checkbox__label {
            font-size: 14px;
          }
        }
      }
    }
  }

  // 隐私
  #privacy-fields {
    .aui-small {
      margin-bottom: 20px;
      font-size: 15px;
      line-height: 1.6;
    }
  }

  .aui-small {
    font-size: 12px;
    line-height: 20px;
  }

  .aui-button-group {
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: top;

    .aui-button {
      border-radius: 0;
      cursor: pointer;
      display: inline-block;
      position: relative;
      padding: 16px 46px;
      outline: 0;
      font-family: inherit;
      font-size: 15px;
      font-weight: 400;
      // line-height: 1.5rem;
      text-align: center;
      text-decoration: none;
      white-space: normal;
      vertical-align: middle;
      transition: all 0.3s cubic-bezier(0.75, 0.02, 0.5, 1);
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      margin: 0 10px 10px 0;
      border: 1px solid transparent;
      background: 0 0;

      .aui-button__text {
        display: inline-block;
        position: relative;
        text-align: left;
      }
    }

    .aui-button-primary {
      border-color: #000;
      background-color: #000;
      color: #fff;

      &:hover, &:active, &.is-active {
        border-color: #333333;
        background-color: #333333;
        color: #fff;
      }
    }
  }

  // 验证提示
  .textfield__counter {
    position: absolute;
    margin-top: 2px;
    font-size: 12px;
    color: red;
    &.ys {
      bottom: -11px;
      margin-top: 0;
    }
    &.grey {
			color: #666;
    }
  }

  @media (min-width: 740px) {
    form {
      .aui-radios-yn {
        width: auto;
      }
    }

    .aui-small {
      font-size: 12px;
      line-height: 20px;
    }
  }

  @media (min-width: 1264px) {
    .aui-small {
      font-size: 12px;
      line-height: 20px;
    }
  }

  @media (min-width: 1584px) {
    .aui-small {
      font-size: 12px;
      line-height: 20px;
    }
  }
}

@media (max-width: 768px) {
  .mt-xs-4 {
    margin-top: 20px !important;
  }

  #ValuationService {
    form {
      .check-text {
        .check-p {
          padding-top: 7px;
          padding-bottom: 12px;
        }
      }
    }

    .textfield__counter {
      &.ys {
        bottom: -14px;
      }
    }
  }

  // 隐私
  #privacy-fields {
    .aui-small {
      font-size: 13px;
    }
  }
}

@media (max-width: 468px) {
  // 第五横，按钮
  #ValuationService {
    form {
      .aui-select-num {
        margin-right: 0;
        padding-right: 0;

        .aui-select {
          width: 126px;
        }
      }

      .check-text {
        .check-p {
          padding-top: 15px;
          padding-bottom: 15px;
        }
      }
    }

    .textfield__counter {
      &.ys {
        bottom: -16px;
      }
    }
  }

  .my-left {
    float: left;
  }

  .my-padding-left {
    padding-left: 0;
  }

  .my-padding-right {
    padding-right: 0;
  }
}

@media (max-width: 380px) {
  // 第五横，按钮
  #ValuationService {
    form {
      .aui-select-num {
        height: 80px;

        .aui-checkbox__label {
          width: 100%;
        }

        .aui-select {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 606px) {
  #ValuationService {
    form {
      .aui-checkbox {
        margin-top: 20px;
      }

      // 隐私
      .check-text {
        .check-p {
          .aui-checkbox {
            height: auto;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ValuationService.vue